import svg4everybody from "svg4everybody";
import Glide, {
    Controls,
    Breakpoints,
    Swipe
} from "@glidejs/glide/dist/glide.modular.esm";

// CUSTOM MODULES
import Styleguide from "./modules/Styleguide";
import Header from "./modules/Header";
import Clippath from "./modules/Clippath";
import Form from "./modules/Form";
import TransitionFlow from "./modules/TransitionFlow";
import Rating from "./modules/Rating";
import BtnSelect from "./modules/BtnSelect";

/**
 *  App class
 *
 *  The App class functions a the main back-bone of the javascript used in this
 *  project.
 *
 */

class App {
    /**
     *  Constructor
     */
    constructor() {
        document.addEventListener(
            "DOMContentLoaded",
            function() {
                this.onDocumentReady();
            }.bind(this)
        );
    }

    onDocumentReady() {
        svg4everybody();

        new Header();
        new Form();

        const clippathElements = document.querySelectorAll(".js-clippath");
        for (let i = 0; i < clippathElements.length; i++) {
            const element = clippathElements[i];
            new Clippath(element);
        }

        const flowHolders = document.querySelectorAll(".js-flow-holder");
        for (let i = 0; i < flowHolders.length; i++) {
            const element = flowHolders[i];
            new TransitionFlow(element);
        }

        const Ratings = document.querySelectorAll(".js-rating");
        for (let i = 0; i < Ratings.length; i++) {
            const element = Ratings[i];
            new Rating(element);
        }

        const BtnSelects = document.querySelectorAll(".js-btn-select");
        for (let i = 0; i < BtnSelects.length; i++) {
            const element = BtnSelects[i];
            new BtnSelect(element);
        }

        const GlideElems = document.querySelectorAll(".js-glide");
        for (let i = 0; i < GlideElems.length; i++) {
            const element = GlideElems[i];
            new Glide(element, {
                gap: 24,
                peek: 120,
                breakpoints: {
                    480: {
                        gap: 0,
                        peek: 0
                    }
                }
            }).mount({ Controls, Breakpoints, Swipe });
        }
    }

    handleStyleguide() {
        new Styleguide();
    }
}

window.app = new App();
